// Composes the workflow-specific Supabase auth adapters into the caller-facing auth port.
import type { AuthPort } from '../core/types';
import { createSupabaseAuthAccountPort } from './createSupabaseAuthAccountPort';
import { createSupabaseAuthCredentialsPort } from './createSupabaseAuthCredentialsPort';
import { createSupabaseVerificationRecoveryPort } from './createSupabaseVerificationRecoveryPort';

export const supabaseAuthPort: AuthPort = {
  ...createSupabaseAuthCredentialsPort(),
  ...createSupabaseVerificationRecoveryPort(),
  ...createSupabaseAuthAccountPort(),
};
